import "core-js/modules/es6.regexp.search";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { MERCURE_OPENING_STATUS } from '~/const/orders';
import pictoCart from '~/assets/img/header/picto-cart@2x.png';

var SearchItem = function SearchItem() {
  return import(
  /* webpackChunkName: "search" */
  '~/components/specific/TheHeader/Menu/SecondaryNav/Items/SearchItem.vue');
};

var LayerFullscreen = function LayerFullscreen() {
  return import(
  /* webpackChunkName: "layer" */
  '~/components/specific/MainHeader/LayerFullscreen.vue');
};

var AlgoliaSearch = function AlgoliaSearch() {
  return import('~/components/organisms/Category/AlgoliaSearch.vue');
};

export default {
  name: 'BannerMobile',
  components: {
    SearchItem: SearchItem,
    LayerFullscreen: LayerFullscreen,
    AlgoliaSearch: AlgoliaSearch
  },
  props: {
    cartUrl: {
      type: String,
      default: ''
    },
    homeUrl: {
      type: String,
      default: ''
    },
    accountUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      algoliaSearchComponent: null,
      algoliaSearch: null,
      isOpenMenu: false,
      mobile: true,
      pictoCart: pictoCart,
      search: '',
      isOpen: false,
      isSearchOpen: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    cart: 'customer/cart',
    total: 'cart/total',
    connected: 'customer/isConnected',
    locale: 'i18n/locale'
  }), {
    htmlClasses: function htmlClasses() {
      var classes = ['global-wrapper'];

      if (this.isOpen) {
        classes.push('active-mobile');
      }

      return classes.join(' ');
    },
    cartTotal: function cartTotal() {
      if (this.$cookies.get('MDM_TEST_MERCURE') || MERCURE_OPENING_STATUS[this.locale.iso]) {
        return this.total;
      }

      return this.cart;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('open-search-mobile', function () {
      _this.isSearchOpen = true;
    });
    this.$root.$on('close-search-mobile', function () {
      _this.isSearchOpen = false;
    });
    this.$root.$on('close-algolia-search', function () {
      _this.closeSearch();
    });
    this.$root.$on('closeMenu', function (shouldChange) {
      if (shouldChange === false) return;

      _this.closeMenu();
    });
  },
  methods: {
    closeSearch: function closeSearch() {
      this.isOpenMenu = false;
      this.algoliaSearchComponent = null;

      if (this.algoliaSearch) {
        this.$root.$emit('generic-tracking', null, {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Fermer'
          }
        });
      }
    },
    toggleSearch: function toggleSearch() {
      this.algoliaSearch = this.$cookies.get('algolia') && this.locale.iso === 'fr-FR';
      var tracking = {
        data: {
          event_category: 'Header',
          event_action: 'Search',
          event_label: 'ES_Clic'
        }
      };

      if (this.algoliaSearch) {
        this.isOpenMenu = true;
        this.algoliaSearchComponent = AlgoliaSearch;
        tracking = {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Clic'
          }
        };
      } else {
        this.isSearchOpen = !this.isSearchOpen;

        if (this.isSearchOpen) {
          this.$refs.search.$refs.search.focus();
        } else {
          this.$refs.search.resetForm();
        }
      }

      this.$root.$emit('generic-tracking', null, tracking);
    },
    tracking: function tracking(evt, data) {
      this.$root.$emit('generic-tracking', evt, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: '',
          event_label: ''
        }, data)
      });
    }
  },
  head: function head() {
    return {
      htmlAttrs: {
        class: this.htmlClasses
      }
    };
  }
};